import { useMountEffect } from "@react-hookz/web";
import { useNavigate } from "react-router";

import type { FC } from "react";

const EmployeeFieldsPage: FC = () => {
  const navigate = useNavigate();

  useMountEffect(() => navigate("/manage/employee_data/merge_tags", { replace: true }));

  return <></>;
};

export default EmployeeFieldsPage;
